export default {
    contractForm: {
        editTitle: 'Edit contract',
        newTitle: 'New contract',
        saveRejected: 'Save rejected',
        counterparty: 'Counterparty',
        counterpartyEic: 'Counterparty EIC',
        externalDealId: 'External deal ID',
        country: 'Country',
        side: 'Side',
        productType: 'Product type',
        tenor: 'Tenor',
        deliveryPeriod: 'Delivery period',
        from: 'FROM',
        to: 'TO',
        profileSource: 'Profile source',
        internalReference: 'Internal reference',
        internalReferencePlaceholder: 'PO / ticket / free text',
        tradeDate: 'Trade date',
        attachments: 'Attachments',
        attachmentsHint: 'Paste URLs to documents (PDF / email / Excel) — up to 20 per contract.',
        mtuFill: 'MTU fill (MW)',
        price: 'Price (€/MW)',
        currency: 'Currency',
        customHelperNote: 'Bins will be set on the editor screen after Continue.',
        reclassifyHint: 'Country can be re-classified (HR ↔ SI). Changing it re-resolves the profile.',
        reclassifyNote: "Re-classifying {from} → {to} re-resolves this contract's profile under the new market calendar (different peak/holiday set) and moves its position between the country books. Requires approval rights.",
        dateLockedNote: "Delivery range can't be changed for a MANUAL_BILATERAL contract — its bins are tied to this window. To use a different range, create a new contract.",
        mtuFillCustomHint: 'Set bins manually in the editor.',
        mtuFillActiveHint: 'Every active {productType} MTU is set to this value. Total is computed automatically.',
        overlapDetected: 'Overlapping commitment detected',
        submitting: 'Submitting…',
        saveChanges: 'Save changes',
        continue: 'Continue →',
        selectCountry: 'Select HR or SI',
        counterpartyRequired: 'Counterparty is required',
        startDateRequired: 'Start date is required',
        endDateRequired: 'End date is required',
        endAfterStart: 'End date must be on or after start date',
        mtuFillPositive: 'MTU fill must be greater than zero',
        pricePositive: 'Price must be greater than zero',
        amendContractIdRequired: 'amend mode requires contractId prop or initial.id',
        unknownError: 'Unknown error',
        contractAmended: 'Contract amended',
        contractCreated: 'Contract created',
    },
}
